import {httpGet,httpPut,httpDelete,httpPost} from '../../../util/request.js';
import appConfig from '../../../config';
import Vue from 'vue';

let vm = new Vue();

export default class ContractApi{
    static listMerchants(param){
        return this.httpRequest('/czyw/contract/merchants',param,'get');
    }

    static listMerchantsAccount(param){
        return this.httpRequest('/czyw/contract/merchants/account', param, 'get');
    }

    static listType(){
        return this.httpRequest("/czyw/contract/type",{},'get');
    }

    static listStore(){
        return this.httpRequest("/czyw/contract/store",{},'get');
    }

    static list(param){
        return this.httpRequest('/czyw/contract/list', param,'get');
    }

    static listCorp(){
        return this.httpRequest('/czyw/contract/corp', {}, 'get');
    }

    static listNcDept(param){
        return this.httpRequest('/czyw/contract/ncdept', param, 'get');
    }

    static listCostType(param){
        return this.httpRequest('/czyw/contract/costType',param,'get');
    }

    static computePeriod(contract){
        return this.httpRequest('/czyw/contract/period', contract, 'post');
    }

    static listOaUser(param){
        return this.httpRequest('/czyw/contract/oaUser',param,'get');
    }

    static saveContract(data){
        return this.httpRequest('/czyw/contract/save', data, 'post');
    }

    static saveContractWithNoValid(data){
        return this.httpRequest('/czyw/contract/save/no/valid', data, 'post');
    }

    static getContract(param){
        return this.httpRequest('/czyw/contract/get', param, 'get');
    }

    static auditContract(param){
        return this.httpRequest('/czyw/contract/audit', param,'get');
    }

    static cancelAuditContract(param){
        return this.httpRequest('/czyw/contract/cancelAudit', param,'get');
    }

    static getContractChangeInfo(param){
        return this.httpRequest('/czyw/contract/change/info', param, 'get');
    }

    static getChangeRecord(param){
        return this.httpRequest('/czyw/contract/change/get', param, 'get');
    }

    static saveChangeInfo(data){
        return this.httpRequest('/czyw/contract/change/save', data, 'post');
    }

    static auditChange(data){
        return this.httpRequest('/czyw/contract/change/audit', data, 'post');
    }

    static closeContract(data){
        return this.httpRequest('/czyw/contract/close', data, 'post');
    }

    static moveContract(data){
        return this.httpRequest('/czyw/contract/move', data, 'post');
    }

    static savePerson(data){
        return this.httpRequest('/czyw/contract/person/save', data, 'post');
    }

    static checkDeposit(param){
        return this.httpRequest('/czyw/contract/deposit/check', param, 'get');
    }

    static savePeriodBase(data){
        return this.httpRequest('/czyw/contract/base/save', data, 'post');
    }

    static saveTemp(data){
        return this.httpRequest('/czyw/contract/temp/save', data, 'post');
    }

    static auditTemp(data){
        return this.httpRequest('/czyw/contract/temp/audit', data, 'post');
    }

    static closeTemp(param){
        return this.httpRequest('/czyw/contract/temp/close', param, 'get')
    }

    static getHistory(param){
        return this.httpRequest('/czyw/contract/history', param, 'get');
    }

    static mendPush(param){
        return this.httpRequest("/czyw/contract/pushOA", param,'post');
    }

    static uploadFile(file){
        let formData = new FormData()
        formData.append('file', file);
        formData.append('mode', 'ftp');
        formData.append('path', 'contract');
        return httpPost(this.baseUrl + '/common/file/upload', formData)
    }

    static baseUrl = appConfig.gatewayUrl+appConfig.smpServicePath;
    // static baseUrl = "http://localhost:10064/smp-service" ;

    static httpRequest(url, param, method ){
        return new Promise((resolve, reject) => {
            if(method == 'get'){
                httpGet(this.baseUrl + url, param).then(resp=>{
                    this.handleResponse(resp, resolve, reject);
                }).catch(err=>{
                    this.handleNetworkError(err, reject);
                })
            }
            if(method == 'post'){
                httpPost(this.baseUrl + url, param).then(resp=>{
                    this.handleResponse(resp, resolve, reject);
                }).catch(err=>{
                    this.handleNetworkError(err, reject);
                })
            }
        });
    }

    static handleResponse(response, resolve,reject){
        let data = response.data;
        if(data.code == 200){
            if(resolve){
                resolve(data.data);
            }
        }else{
            let text = data.errMsg
            vm.$dialog.error({
                text: text,
                title: "错误"
            });
            if(reject){
                reject(data);
            }
        }
    }

    static handleNetworkError(response, reject){
        vm.$dialog.error({
            text: response.message,
            title: "错误"
        });
        if(reject){
            reject(response);
        }
    }

}